export default {
  "app-footer": () => import("/home/forge/career.proxify.io/releases/20261105110027/layouts/AppFooter/AppFooter.vue"),
  "app-header": () => import("/home/forge/career.proxify.io/releases/20261105110027/layouts/AppHeader/AppHeader.vue"),
  newsletter: () => import("/home/forge/career.proxify.io/releases/20261105110027/layouts/Newsletter/Newsletter.vue"),
  default: () => import("/home/forge/career.proxify.io/releases/20261105110027/layouts/default.vue")
}